// Context: https://stackoverflow.com/a/71619350
export const emojiSafeCharacterSplit = (text) => {
    if (!text) {
        return [];
    }
    return [...new Intl.Segmenter().segment(text)].map((x) => x.segment);
};
